export default function removeFlashMessage(flashMessage, messageType) {
  return {
    type: "FLASH_MESSAGE_REMOVE",
    flashMessage,
    messageType
  };
}
